// ═══════════════════════════════════════════════════════════════════
//  modules/chat/constantes.js
//  CHAT_PROJECT_NAME · CHAT_TASK_CATEGORIES · SUJ_CANAUX · SUJ_CANAL_COURT · SUJ_CATEGORIES · SUJ_CATEGORIE_IDS · SUJ_SEVERITES · SUJ_STATUTS · SUJ_TRIS
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../../socle/theme";
import { CATEGORY_LABELS } from "../projets/constantes";

// ═══════════════════════════════════════════════════════════════════════
//  MODULE CHAT EN JEU — Historique · Statistiques · Analyses IA     v3.0
//
//  Onglet « Analyses IA » : 3 sous-onglets (Analyse générale · MP · BoxChat).
//  Page d'accueil de chaque sous-onglet, dans l'ordre :
//     1. Récap global (synthèse de fond) + Récap quotidien
//     2. Vie du serveur — le « petit rapport simple », sans tâche
//     3. Compteurs + état du système
//     4. Registre de sujets filtrable
//
//  ⚠️ MODE D'EMPLOI — voir INSTALLATION_Analyse_IA_Chat.md.
//  Ce fichier remplace tout le bloc « MODULE CHAT EN JEU » de App.js
//  (jusqu'à `function Dashboard(...)` exclu). Deux petites retouches
//  ailleurs dans App.js sont décrites dans la notice (étapes 6 et 7).
//
//  Aucun nouvel import. Dépendances déjà présentes dans App.js :
//  THEME, API_BASE, useState, useEffect, useIsMobile, Badge, CATEGORY_LABELS.
// ═══════════════════════════════════════════════════════════════════════

// ═══════════════════════════════════════════════════════════════════════
//  ⚠️ IMPORTANT — les 3 catégories de tâches du projet « Analyse Chat »
//  sont injectées ici dans CATEGORY_LABELS (défini plus haut dans App.js).
//  C'est volontaire : ça évite de modifier CATEGORY_LABELS à la main.
//  Ces catégories n'apparaissent QUE dans le projet « Analyse Chat »,
//  grâce à categoriesForProject() utilisée par ProjectView (étape 7).
// ═══════════════════════════════════════════════════════════════════════
export const CHAT_PROJECT_NAME = "Analyse Chat";

export const CHAT_TASK_CATEGORIES = ["chat_bug", "chat_suggestion", "chat_comportement"];

Object.assign(CATEGORY_LABELS, {
  chat_bug: { label: "Bug", color: "#F85149", bg: "#3D1515" },
  chat_suggestion: { label: "Suggestion", color: "#FF8B3D", bg: "#3D2211" },
  chat_comportement: { label: "Comportement à surveiller", color: "#4F8EF7", bg: "#1E3A6E" },
});

// ── Référentiels d'affichage de l'analyse ─────────────────────────────
// `restreint` : canal réservé aux fondateurs et administrateurs. Le backend
// (modules/chat-analysis.js) refuse déjà les routes en 403 pour les autres
// rôles ; ce drapeau sert seulement à ne pas afficher un onglet inutilisable.
export const SUJ_CANAUX = [
  { id: "general", label: "Analyse générale", icon: "🌐", attente: "en attente plugin" },
  { id: "mp", label: "MP", icon: "✉️", attente: "en attente plugin" },
  { id: "boxchat", label: "BoxChat", icon: "🏝️", attente: "en attente plugin" },
  { id: "staff", label: "Chat Staff", icon: "🛡️", attente: "en attente plugin", restreint: true },
  { id: "discord", label: "Global Discord", icon: "💬", attente: "en attente du bot" },
];

// Rôles autorisés sur les canaux restreints. À garder aligné sur
// ROLES_CHAT_STAFF côté backend (server.js et modules/chat-analysis.js).
export const SUJ_ROLES_RESTREINTS = ["super_admin", "admin"];

// Fusion jeu ↔ Discord : un bug vu des deux côtés = UN seul sujet.
// Ces helpers affichent d'où il remonte, et avec quel compteur par canal.
// Le canal staff est volontairement hors fusion : il garde ses sujets à lui.
export const SUJ_CANAL_COURT = { general: "jeu", mp: "MP", boxchat: "BoxChat", staff: "Chat Staff", discord: "Discord" };

export const SUJ_CATEGORIES = {
  bug: { label: "Bug", icon: "🐛", color: THEME.emerald, tache: "chat_bug" },
  exploit: { label: "Exploit", icon: "⚠️", color: THEME.amber, tache: "chat_bug" },
  plainte: { label: "Plainte", icon: "😡", color: THEME.red, tache: "chat_comportement" },
  attention_staff: { label: "Attention staff", icon: "🚨", color: THEME.purple, tache: "chat_comportement" },
  suggestion: { label: "Suggestion", icon: "💡", color: THEME.gold, tache: "chat_suggestion" },
  question_recurrente: { label: "Question récurrente", icon: "❓", color: THEME.accent, tache: null },
  vie_serveur: { label: "Vie du serveur", icon: "🤝", color: "#6FD3C7", tache: null },
};

export const SUJ_CATEGORIE_IDS = Object.keys(SUJ_CATEGORIES);

export const SUJ_SEVERITES = {
  critique: { label: "Critique", color: THEME.red, bg: THEME.redDim },
  elevee: { label: "Élevée", color: THEME.red, bg: THEME.redDim },
  moyenne: { label: "Moyenne", color: THEME.amber, bg: THEME.amberDim },
  faible: { label: "Faible", color: THEME.textMuted, bg: THEME.surface },
};

export const SUJ_STATUTS = [
  { id: "ouvert", label: "Ouvert" },
  { id: "resolu", label: "Résolu" },
  { id: "ignore", label: "Ignoré" },
  { id: "tous", label: "Tous" },
];

export const SUJ_TRIS = [
  { id: "severite", label: "Sévérité · occ." },
  { id: "occurrences", label: "Occurrences ↓" },
  { id: "last_seen", label: "Dernière occ. ↓" },
];
